import {
  toLocalMidnightDate,
  isLocalDateAfter,
  type DateLike,
} from '@/utils/localDateOnly';

/**
 * Registration closes at least one full day before play starts, so the latest day the deadline may
 * land on is the day before the tournament's first match. Only the calendar day matters here — the
 * hour the manager picks inside that day is free.
 */
export function latestSignupDeadlineDay(tournamentStart: DateLike): Date | null {
  const start = toLocalMidnightDate(tournamentStart);
  if (!start) return null;

  const latest = new Date(start);
  latest.setDate(latest.getDate() - 1);
  return latest;
}

/**
 * True when the deadline breaks that rule. Returns false when either side is missing, so a caller
 * with no known start date does not block the manager.
 */
export function isSignupDeadlineTooLate(
  deadline: DateLike,
  tournamentStart: DateLike,
): boolean {
  const latest = latestSignupDeadlineDay(tournamentStart);
  if (!latest) return false;
  return isLocalDateAfter(deadline, latest) === true;
}
